import { useState } from 'react'
import s from './AddContact.scss'
import { AllDashboardComponent } from '../DictionaryDashboard'
import { FaIdBadge } from 'react-icons/fa'
import { ContactModalContainer } from 'components/common/modals/ContactModalContainer'

const AddContact = ({ type, layoutLocked }) => {
  const [isAddContactModalVisible, setIsAddContactModalVisible] = useState(false)

  return (
    <>
      <div
        onClick={layoutLocked ? () => setIsAddContactModalVisible(true) : null}
        className={s.wrapper}
        data-cy="add_new_contact"
      >
        <>
          <FaIdBadge className={s.icon} />
          <div>
            <h6>{AllDashboardComponent[type].label}</h6>
            <p>
              iDeal CRM is your centralized system for all your contacts and clients. Enter them in
              the database and link them to your opportunities/projects to have an overall view of
              all your clients and projects you are bidding, winning, losing with each.
            </p>
          </div>
          <div className={s.action}>{'Enter Contact/Company'.toUpperCase()}</div>
        </>
      </div>
      {isAddContactModalVisible && (
        <ContactModalContainer
          showContactModal={isAddContactModalVisible}
          toggleContactModal={() => setIsAddContactModalVisible(false)}
          actionType="CONTACT_CREATE_REQUESTED"
        />
      )}
    </>
  )
}

export default AddContact
